import SockJS from "sockjs-client";
import Stomp from "stompjs";

const getSocketConnection = (socketUrl: string, query: string) => {
    const sockjsInstance = new SockJS(`${socketUrl}/ws/connect/?${query}`);
    const stompInstance = Stomp.over(sockjsInstance);
    stompInstance.debug = () => { };
    return stompInstance;
}

export default getSocketConnection;